import lazyLoad from '@utils/lazyLoad'

const goodsRoutes = [
  {
    path: '/goodsManagement/data', // 商品库
    exact: true,
    component: lazyLoad(() => import('@views/AppMails/GoodsManagement/Data')),
    layoutMode: 'empty',
    meta: {
      title: '商品库',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/data/create/:id', // 新建商品
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Data/Update.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '新建商品',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/data/edit/:id', // 编辑商品
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Data/Update.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '编辑商品',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/audit', // 商品审核
    exact: true,
    component: lazyLoad(() => import('@views/AppMails/GoodsManagement/Audit')),
    layoutMode: 'empty',
    meta: {
      title: '商品库',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/combination', // 组合商品
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Combination')
    ),
    layoutMode: 'empty',
    meta: {
      title: '商品库',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/distribution', // 配送设置
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Distribution')
    ),
    layoutMode: 'empty',
    meta: {
      title: '商品库',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/distribution/edit/:id', // 编辑运费模板
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Distribution/Update.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '编辑运费模板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/distribution/new/:id', // 新增运费模板
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Distribution/Update.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '新增运费模板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/distribution/editAddress/:id', // 编辑
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Distribution/AddressUpdate.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '编辑地址',
      layoutMode: 'empty'
    }
  },
  {
    path: '/goodsManagement/distribution/newAddress/:id', // 新增
    exact: true,
    component: lazyLoad(() =>
      import('@views/AppMails/GoodsManagement/Distribution/AddressUpdate.js')
    ),
    layoutMode: 'empty',
    meta: {
      title: '新增地址',
      layoutMode: 'empty'
    }
  }
]

export default goodsRoutes
